module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/battery.3b5db0e5.svg";